module.exports = __webpack_public_path__ + "assets/images/Coin50C.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Coin50C.png
// module id = 1351
// module chunks = 1